module.exports = __webpack_public_path__ + "img/CHECK.8a4ad6e3.svg";